import { useContextFallback } from '@prenuvo/halo';

import { ReportIssueContext } from './report-issue.context';

export const useReportIssue = () => useContextFallback(ReportIssueContext);
